const bookcase = require("./bookcase.jpg");
const sealSquare = require("./seal_square.jpg");
const bathroom = require("./bathroom_panelling.jpg");
const JA_kitchen = require("./JA_kitchen.jpg");
const allSlides = [JA_kitchen, bookcase, sealSquare, bathroom];

export default allSlides;
